import { useContext } from 'react';
import { AuthContext } from '../providers';

// Auth hook for child components to get the auth object
export const useAuth = () => useContext(AuthContext);
